import React from 'react';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import moment from 'moment';

import {
  DateRangeItem,
  useDateRangesInputContext,
} from './DateRangesInput.context';
import { RangeItemContainer } from './RangeItemContainer';

type RangeItemProps = DateRangeItem & {
  mode: 'default' | 'reply' | 'suggest';
  disable?: boolean;
};

export const RangeItem = ({
  start: startDate,
  end: endDate,
  id: rangeItemId,
  mode = 'default',
  disable,
}: RangeItemProps) => {
  const {
    disabled,
    reply,
    dateRanges,
    activeDateRange,
    setDateRanges,
    setActiveDateRange,
  } = useDateRangesInputContext();

  const start = startDate ? moment(startDate).format('MM/DD') : '';
  const end = endDate ? moment(endDate).format('MM/DD') : '';
  const range = `${start} - ${end}`;

  return (
    <RangeItemContainer
      selected={
        rangeItemId === activeDateRange?.index &&
        (mode === activeDateRange.mode ||
          (reply && mode === 'default' && activeDateRange.mode === 'reply'))
      }
      mode={mode}
      onClick={() => {
        setActiveDateRange({
          mode: reply && mode === 'default' ? 'reply' : mode,
          index: rangeItemId,
        });
      }}
      action={
        (!disabled &&
          mode === 'default' &&
          activeDateRange.mode === 'default' &&
          dateRanges?.[activeDateRange.mode] &&
          dateRanges?.[activeDateRange.mode]) ||
        [].length > 1 ||
        (mode !== 'default' && rangeItemId > 0) ? (
          <IconButton
            color="inherit"
            size="small"
            onClick={e => {
              e.stopPropagation();
              const remainingRange =
                dateRanges?.[mode]?.filter(item => item.id !== rangeItemId) ||
                [];
              setDateRanges({
                ...dateRanges,
                [mode]: remainingRange,
              });
              if (remainingRange.length > 0) {
                setActiveDateRange({
                  mode,
                  index:
                    dateRanges?.[mode]?.filter(
                      item => item.id !== rangeItemId
                    )?.[0]?.id ||
                    dateRanges?.default?.[0]?.id ||
                    0,
                });
              } else {
                setActiveDateRange({
                  mode: reply ? 'reply' : 'default',
                  index: dateRanges?.default?.[0]?.id || 0,
                });
              }
            }}
          >
            <Close sx={{ fontSize: 'inherit' }} />
          </IconButton>
        ) : (
          <div />
        )
      }
    >
      {range}
    </RangeItemContainer>
  );
};
